export default {
  unities: [],
  unity: null,
  pagination: {}
};
